import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AlertService, EventService, UserService } from '../_services';
import { UserEvent } from '../_models';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
interface Event {
  id: number;
  name: string;
  date: string;
  location: string;
}
@Component({
  selector: 'app-event-list',
  templateUrl: './event-list.component.html',
  styleUrls: ['./event-list.component.scss']
})
export class EventListComponent implements OnInit {

  events: UserEvent[];
  deleteEvent: UserEvent;
  //deleteEventConfirm
  confirmModalRef: BsModalRef;
  @ViewChild('deleteEventConfirm')
  private deleteEventConfirm: TemplateRef<any>;
  //  = [
  //   { id: 1, name: 'Angular Meetup', date: '2025-11-10', location: 'Bangalore' },
  //   { id: 2, name: 'PrimeNG Summit', date: '2025-11-12', location: 'Mumbai' },
  //   // ... add more events
  // ];

  constructor(private eventService: EventService, private userService: UserService, private router: Router, private alertService: AlertService, private modalService: BsModalService) { }

  ngOnInit(): void {
    this.getUserEvents(this.userService.sessionUser.email);
  }

  getUserEvents(user: string): void {
    this.eventService.getUserEvents(user).subscribe(
      (data) => {
        this.events = data; // Store the API response
      },
      (error) => {
        console.error('Error fetching user events:', error);
      }
    );
  }

  createNewEvent() {
    // Implement your create new event logic
    this.eventService.getNewEventId().subscribe(
      (data) => {
        const newEventId = data.eventId;
        this.router.navigate(['/event/', newEventId, 'location']);
      },
      (error) => {
        console.error('Error getting new event ID:', error);
      }
    );
  }


  onView(event: Event) {
    // Implement your view logic
    alert('Viewing: ' + event.name);
  }

  onEdit(event: Event) {
    // Implement your edit logic
    alert('Editing: ' + event.name);
  }

  confirmDeleteEvent(event: UserEvent) {
    this.deleteEvent = event;
    this.confirmModalRef = this.modalService.show(this.deleteEventConfirm, { class: 'modal-md' });
  }

  confirmDelete() {
    this.eventService.deleteEvent(this.deleteEvent).subscribe(
      data => {
        this.alertService.success(data.message, true);
        this.getUserEvents(this.userService.sessionUser.email);
      },
      (error: HttpErrorResponse) => {
        console.log(`Error: ${error}`);
        this.alertService.error(error.error.message);
      }
    );
    this.confirmModalRef.hide();
  }

  decline() {
    this.confirmModalRef.hide();
  }

}
